import { PartnerPartnersRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

/**
 * The CSV export of the partner list: the same query as the listing, unpaginated. Kept apart from
 * useFetchPartnerPartners because an ExportCSV response carries no Partners, so routing it through
 * the listing hook would blank the rows on screen.
 */
export default function useExportPartnerPartners() {
  const [exportingPartners, setExportingPartners] = useState(false);

  async function exportPartnerPartners(params: Omit<PartnerPartnersRequest, 'ExportCSV' | 'Offset' | 'Limit'>) {
    try {
      setExportingPartners(true);
      const res = await api.fetchPartnerPartners({ ...params, ExportCSV: true });
      if (!res.Success) throw new Error(res.ErrorMessage);
      if (!res.CSVFile) throw new Error('The export returned no CSV file.');

      return res.CSVFile;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setExportingPartners(false);
    }
  }

  return { exportingPartners, exportPartnerPartners };
}
